<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container" @click.stop.prevent="isSearchShow = false">
      <div class="commentBox">
        <div class="title clearfix">
          {{ $t("people.视频评论") }}
          <div class="searchBox">
            {{ $t("people.筛选视频") }}
            <div
              class="search"
              :class="{ isFocus: isSearchShow }"
              @click.stop.prevent
            >
              <input
                @focus="inputFocus"
                :placeholder="$t('people.请输入视频名称搜索')"
                type="text"
                v-model="keyword"
              />
              <div class="searchList" v-if="isSearchShow">
                <p class="all" @click.stop.prevent="getAllVideo">
                  {{ $t("people.全部视频") }}
                </p>
                <div class="listsBox">
                  <p
                    class="listName"
                    v-for="(item, i) in searchList"
                    :key="i"
                    @click="getKeyVideo(item)"
                  >
                    {{ item.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="selectBox">
          <p class="number">
            {{
              $t("people.共x条", {
                count: totalRecord,
              })
            }}
          </p>
          <div class="selectBut" v-if="commentList.length">
            <span class="allSelect" @click="selectAll"
              ><i v-if="!isAll"></i
              ><img
                v-else
                src="/static/uploadvideo/icon_upload_multi_selected@2x.png"
                alt=""
              />{{ $t("global.全选") }}</span
            >
            <span class="selected" :class="{ isActive: selectId.length }">{{
              $t("people.已选x条", {
                count: selectId.length,
              })
            }}</span>
            <span
              class="allDetele"
              @click="deleteComment"
              :class="{ isActive1: selectId.length }"
              >{{ $t("people.批量删除") }}</span
            >
          </div>
        </div>
        <div class="commentList">
          <div class="listBox" v-if="commentList.length">
            <div class="list" v-for="(item, i) in commentList">
              <div class="textBox clearfix">
                <div class="sele" @click="selectDetele(item)">
                  <i v-if="selectId.indexOf(item.id) == -1"></i
                  ><img
                    v-else
                    src="/static/uploadvideo/icon_upload_multi_selected@2x.png"
                    alt=""
                  />
                </div>
                <div class="comBox">
                  <p class="name">
                    <span
                      @click="gotoPeople(item.userId)"
                      class="avatar"
                      :class="{ userType2: item.userType === 2 && item.isCertification === 1 }"
                      ><img
                        :src="item.userAvatar | imageUrl('', '80', '80')"
                        alt=""
                    /></span>
                    <span @click="gotoPeople(item.userId)" class="nick">{{
                      item.userNickName
                    }}</span>
                    <span class="time">{{
                      item.createTime | dateToNow(language)
                    }}</span>
                  </p>
                  <p class="title">{{ item.content }}</p>
                  <p class="dele" @click="deleteOne(item.id)">
                    {{ $t("global.删除") }}
                  </p>
                </div>
                <div class="videoBox" @click="gotoVideo(item)">
                  <div class="imgBox">
                    <img
                      :src="
                        item.videoResponse.thumb | imageUrl('', '280', '160')
                      "
                      alt=""
                    />
                    <span>{{
                      item.videoResponse.duration | secondToDate
                    }}</span>
                  </div>
                  <p class="intro">{{ item.videoResponse.title }}</p>
                </div>
              </div>
              <div
                class="childList"
                v-for="(childItem, y) in parentId == item.id
                  ? childList
                  : item.childrenPageList.list"
                :key="y"
                v-if="item.childrenPageList.list.length"
              >
                <div class="textBox1 clearfix">
                  <!-- <div class="sele1" @click="selectDetele(childItem)">
                    <i v-if="selectId.indexOf(childItem.id) == -1"></i
                    ><img
                      v-else
                      src="/static/uploadvideo/icon_upload_multi_selected@2x.png"
                      alt=""
                    />
                  </div> -->
                  <div class="comBox1">
                    <p class="name1">
                      <span
                        @click="gotoPeople(childItem.userId)"
                        class="avatar1"
                        :class="{ userType2: childItem.userType === 2 && childItem.isCertification === 1 }"
                        ><img
                          :src="childItem.userAvatar | imageUrl('', '80', '80')"
                          alt=""
                      /></span>
                      <span
                        @click="gotoPeople(childItem.userId)"
                        class="nick1"
                        >{{ childItem.userNickName }}</span
                      >
                      <span class="time1">{{
                        childItem.createTime | dateToNow(language)
                      }}</span>
                    </p>
                    <p class="title1">
                      <span class="reply" v-if="childItem.atUserNickName">
                        <span class="replyText">{{ $t("global.回复") }}</span
                        ><span
                          class="replyName"
                          @click="gotoPeople(childItem.atUserId)"
                          >@{{ childItem.atUserNickName }}</span
                        >
                      </span>
                      {{ childItem.content }}
                    </p>
                    <p class="dele1" @click="deleteOne(childItem.id)">
                      {{ $t("global.删除") }}
                    </p>
                  </div>
                </div>
              </div>
              <p
                class="seeAll"
                @click="showMoreChild(item)"
                v-if="
                  item.childrenPageList.totalRecord >
                    item.childrenPageList.list.length && !isChilds
                "
              >
                {{
                  $t("global.查看全部x条回复", {
                    count: item.childrenPageList.totalRecord,
                  })
                }}
              </p>
            </div>
          </div>
          <div class="noData" v-else>
            <img src="/static/v2/article/article_comment_empty.png" alt="" />
            <p class="noTitle">{{ $t("people.没有评论") }}</p>
          </div>
          <pagination
            :totalRecord="totalRecord"
            :pageSize="pageSize"
            :pageIndex="pageIndex"
            @OnCurrentChanged="changePage"
          />
        </div>
      </div>
    </div>
    <div class="createPop" v-if="popupDiv">
      <div class="popBox">
        <p class="popTitle">
          <span class="title1">{{ $t("people.删除评论") }}</span
          ><img
            class="close"
            @click="popupDiv = false"
            src="/static/close_btn@2x.png"
            alt=""
          />
        </p>
        <div class="deteleBox">
          <p class="deteleTitle">
            {{ $t("people.是否永久删除该评论？") }}
          </p>
          <div class="buttomBox">
            <span class="yes" @click="deleteOk">{{ $t("global.是") }}</span>
            <span class="no" @click="popupDiv = false">{{
              $t("global.否")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import Pagination from "@/components/v2/Pagination";
export default {
  name: "videoComment",
  metaInfo() {
    return {
      title: this.$t("people.视频评论") + " | MANA",
    };
  },
  data() {
    return {
      keyword: "",
      pageIndex: 1,
      pageSize: 10,
      totalRecord: 0,
      commentList: [],
      isChilds: false,
      parentId: null,
      childList: [],
      selectId: [],
      isAll: false,
      popupDiv: false,
      id: null,
      index: null,
      videoId: null,
      isSearchShow: false,
      searchList: [],
    };
  },
  components: {
    MainLayout,
    Pagination,
  },
  created() {
    this.getComment();
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  watch: {
    selectId(val) {
      if (val.length === this.totalRecord && val.length) {
        this.isAll = true;
      } else {
        this.isAll = false;
      }
    },
    keyword(val) {
      if (val) {
        this.keyword = val;
        this.getSearchVideo();
      } else {
        this.searchList = [];
      }
    },
  },
  methods: {
    gotoVideo(item) {
      let routeData = this.$router.resolve({
        path: "/video/detail?id=" + item.videoResponse.id,
      });
      window.open(routeData.href, "_blank");
    },
    gotoPeople(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id,
      });
      window.open(routeData.href, "_blank");
    },
    inputFocus() {
      this.isSearchShow = true;
    },
    getAllVideo() {
      this.keyword = "";
      this.videoId = null;
      this.getComment();
      this.isSearchShow = false;
    },
    getKeyVideo(item) {
      this.keyword = item.name;
      this.videoId = item.videoId;
      this.selectId = [];
      this.id = null;
      this.isAll = false;
      this.getComment();
      this.isSearchShow = false;
    },
    getSearchVideo() {
      this.$http
        .get("/api/u/video/list2", {
          params: {
            tab: 0,
            pageIndex: 1,
            pageSize: 10,
            orderColumn: 1,
            order: 1,
            keyword: this.keyword,
            videoId: "",
          },
        })
        .then((res) => {
          this.searchList = res.data.list;
        });
    },
    selectAll() {
      this.selectId = [];
      if (this.isAll) {
        this.isAll = false;
      } else {
        for (let i = 0; i < this.commentList.length; i++) {
          this.selectId.push(this.commentList[i].id);
        }
        this.isAll = true;
      }
    },
    selectDetele(item) {
      let index = this.selectId.indexOf(item.id);
      if (index == -1) {
        this.selectId.push(item.id);
      } else {
        this.selectId.splice(index, 1);
      }
    },
    showMoreChild(item) {
      this.$http
        .get("/api/mobile/comment/childrenCommentList", {
          params: {
            parentId: item.id,
            pageIndex: 1,
            pageSize: item.childrenPageList.totalRecord,
            type: 1,
          },
        })
        .then((res) => {
          if (res.code == "OK") {
            this.isChilds = true;
            this.childList = res.data.list;
            this.parentId = item.id;
          } else {
            this.$message(res.message);
          }
        });
    },
    changePage(index) {
      this.pageIndex = index;
      this.selectId = [];
      this.id = null;
      this.isAll = false;
      this.getComment();
    },
    getComment() {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        videoId: this.videoId,
      };
      this.$http.get("/api/u/video/commentList", { params }).then((res) => {
        this.commentList = res.data.list;
        this.totalRecord = res.data.totalRecord;
      });
    },
    deleteComment() {
      if (this.selectId.length) {
        this.popupDiv = true;
        this.index = 2;
      } else {
        return;
      }
    },
    deleteOne(id) {
      this.popupDiv = true;
      this.id = id;
      this.index = 1;
    },
    deleteOk() {
      let ids = [];
      if (this.index == 1) {
        ids.push(this.id);
      }
      if (this.index == 2) {
        ids = this.selectId;
      }
      let params = {
        ids: ids,
      };
      this.$http
        .post("/api/u/video/comment/delete", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.code === "OK") {
            this.$message.success(res.message);
            this.popupDiv = false;
            this.selectId = [];
            this.id = null;
            this.isAll = false;
            this.getComment();
          }
        });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  width: 100%;

  .commentBox {
    width: 920px;
    margin: 0 auto;
    padding: 50px 0;

    .title {
      font-size: 24px;
      font-weight: 600;
      color: #333333;

      .searchBox {
        float: right;
        font-size: 14px;
        font-weight: 400;
        color: #666666;

        .search {
          display: inline-block;
          width: 250px;
          height: 40px;
          background: #F5F5F5;
          margin-left: 12px;
          position: relative;
          box-sizing: border-box;
          border: 1px solid #F5F5F5;

          input {
            padding-left: 12px;
            width: 200px;
            height: 36px;
            line-height: 36px;
            border: none;
            background: #F5F5F5;
          }

          .searchList {
            width: 248px;
            position: absolute;
            background: #FFFFFF;
            box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
            border: 1px solid #EBEBEB;
            left: 0;
            top: 44px;
            cursor: pointer;
            z-index: 11;

            .all {
              padding-left: 20px;
              height: 54px;
              line-height: 54px;
              font-size: 14px;
              font-weight: 500;
              color: #3664ED;
              border-bottom: 1px solid rgba(235, 235, 235, 1);
            }

            .listsBox {
              .listName {
                height: 34px;
                line-height: 34px;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                padding: 0 12px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                &:hover {
                  background: #F5F5F5;
                }
              }
            }
          }
        }

        .isFocus {
          border: 1px solid #2026CC;
        }
      }
    }

    .selectBox {
      margin-top: 24px;

      .number {
        height: 24px;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        margin-bottom: 28px;
      }

      .selectBut {
        .allSelect {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          cursor: pointer;

          i {
            display: inline-block;
            width: 18px;
            height: 18px;
            border: 2px solid #B8B8B8;
            vertical-align: middle;
            margin-right: 8px;
            box-sizing: border-box;
          }

          img {
            width: 18px;
            height: 18px;
            margin-right: 8px;
          }
        }

        .selected {
          font-size: 14px;
          font-weight: 400;
          color: #B8B8B8;
          margin: 0 20px;
        }

        .isActive {
          color: #999;
        }

        .allDetele {
          font-size: 14px;
          font-weight: 400;
          color: #B8B8B8;
        }

        .isActive1 {
          color: #2026CC;
          cursor: pointer;
        }
      }
    }

    .commentList {
      margin-top: 24px;

      .listBox {
        .list {
          border-top: 1px solid rgba(235, 235, 235, 1);
          padding: 20px 0;

          .textBox {
            .sele {
              float: left;
              width: 18px;
              padding-top: 11px;
              cursor: pointer;

              i {
                display: inline-block;
                width: 18px;
                height: 18px;
                border: 2px solid #B8B8B8;
                vertical-align: middle;
                box-sizing: border-box;
              }

              img {
                width: 18px;
                height: 18px;
              }
            }

            .comBox {
              width: 710px;
              float: left;
              margin: 0 32px 0 20px;

              .name {
                cursor: pointer;

                .avatar {
                  position: relative;
                  display: inline-block;
                  width: 40px;
                  height: 40px;

                  img {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                  }
                }

                .userType2::before {
                  content: '';
                  left: 25px;
                  bottom: 0;
                  position: absolute;
                  width: 16px;
                  height: 16px;
                  background: url('/static/v2/match/Verified_icon_blue_20.png');
                  background-size: 16px;
                }

                .nick {
                  font-size: 15px;
                  font-weight: 500;
                  color: #333333;
                  margin: 0 20px 0 10px;
                  cursor: pointer;
                }

                .time {
                  font-size: 14px;
                  font-weight: 400;
                  color: #B8B8B8;
                }
              }

              .title {
                padding-left: 50px;
                font-size: 15px;
                font-weight: 400;
                color: #0A0A0A;
                line-height: 24px;
                margin: 10px 0 12px 0;
                word-break: break-word;
              }

              .dele {
                cursor: pointer;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
                margin-left: 50px;
                display: inline-block;
              }
            }

            .videoBox {
              float: left;
              width: 140px;
              cursor: pointer;

              .imgBox {
                position: relative;

                img {
                  width: 140px;
                  height: 80px;
                }

                span {
                  position: absolute;
                  padding: 0 6px;
                  height: 16px;
                  background: rgba(10, 10, 10, 0.8);
                  right: 0;
                  bottom: 0;
                  line-height: 16px;
                  text-align: center;
                  font-size: 12px;
                  font-weight: 400;
                  color: #FFFFFF;
                }
              }

              .intro {
                margin-top: 8px;
                height: 36px;
                font-size: 12px;
                font-weight: 400;
                color: #666666;
                line-height: 18px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                /* autoprefixer: off */
                -webkit-box-orient: vertical;
                /* autoprefixer: on */
                -webkit-line-clamp: 2;
              }
            }
          }

          .childList {
            margin-top: 20px;

            .textBox1 {
              .sele1 {
                float: left;
                width: 18px;
                padding-top: 11px;

                i {
                  display: inline-block;
                  width: 18px;
                  height: 18px;
                  border: 2px solid #B8B8B8;
                  vertical-align: middle;
                  box-sizing: border-box;
                }

                img {
                  width: 18px;
                  height: 18px;
                }
              }

              .comBox1 {
                width: 660px;
                float: left;
                margin: 0 32px 0 20px;
                padding-left: 50px;

                .name1 {
                  cursor: pointer;

                  .avatar1 {
                    position: relative;
                    display: inline-block;
                    width: 40px;
                    height: 40px;

                    img {
                      width: 40px;
                      height: 40px;
                      border-radius: 50%;
                    }
                  }

                  .userType2::before {
                    content: '';
                    left: 25px;
                    bottom: 0;
                    position: absolute;
                    width: 16px;
                    height: 16px;
                    background: url('/static/v2/match/Verified_icon_blue_20.png');
                    background-size: 16px;
                  }

                  .nick1 {
                    font-size: 15px;
                    font-weight: 500;
                    color: #333333;
                    margin: 0 20px 0 10px;
                    cursor: pointer;
                  }

                  .time1 {
                    font-size: 14px;
                    font-weight: 400;
                    color: #B8B8B8;
                  }
                }

                .title1 {
                  padding-left: 50px;
                  font-size: 15px;
                  font-weight: 400;
                  color: #0A0A0A;
                  line-height: 24px;
                  margin: 10px 0 12px 0;
                  word-break: break-word;

                  .reply {
                    .replyText {
                      font-size: 14px;
                      font-weight: 400;
                      color: #B8B8B8;
                      margin-right: 4px;
                    }

                    .replyName {
                      font-size: 15px;
                      font-weight: 600;
                      color: #333333;
                      cursor: pointer;
                    }
                  }
                }

                .dele1 {
                  cursor: pointer;
                  font-size: 14px;
                  font-weight: 400;
                  color: #666666;
                  margin-left: 50px;
                  display: inline-block;
                }
              }
            }
          }

          .seeAll {
            color: #2026CC;
            font-size: 14px;
            display: inline-block;
            margin-left: 120px;
            cursor: pointer;
            margin-top: 20px;

            &::after {
              content: '';
              display: inline-block;
              background: url('/static/v2/article/comment_open_arrow.png');
              background-size: 9px;
              width: 9px;
              height: 9px;
              margin-left: 4px;
            }
          }
        }
      }

      .noData {
        width: 920px;
        padding: 90px 0 250px 0;
        text-align: center;
        border-top: 1px solid rgba(235, 235, 235, 1);

        img {
          width: 88px;
          height: 88px;
          margin-bottom: 14px;
        }

        .noTitle {
          height: 21px;
          font-size: 15px;
          font-weight: 400;
          color: #B8B8B8;
          line-height: 21px;
        }
      }
    }
  }
}

.createPop {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;

  .popBox {
    width: 445px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .popTitle {
      height: 60px;
      line-height: 60px;
      padding-left: 24px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      position: relative;
      border-bottom: 1px solid #E0E0E0;

      .close {
        position: absolute;
        right: 24px;
        top: 23px;
        width: 13px;
        height: 13px;
        cursor: pointer;
      }
    }

    .deteleBox {
      padding-bottom: 36px;

      .deteleTitle {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        padding: 27px 0 32px 0;
        text-align: center;
      }

      .buttomBox {
        text-align: center;

        .yes {
          display: inline-block;
          width: 136px;
          height: 40px;
          background: #2026CC;
          line-height: 40px;
          font-size: 16px;
          font-weight: 600;
          color: #FFFFFF;
          margin-right: 28px;
          cursor: pointer;
        }

        .no {
          display: inline-block;
          width: 136px;
          height: 38px;
          border: 1px solid #999999;
          line-height: 38px;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/video/videoComment.vue